import { useState, useCallback } from "react";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const AddTranscriptModal = ({ onClose,onSave, videoCode, enableChapterRegeneration }) => {
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [transcript, setTranscript] = useState("");
    const [saving, setSaving] = useState(false);

    const handleSave = useCallback(() => {
        setSaving(true);
        axios.post(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
            VideoID: videoCode,
            data: {
                start: +startTime,
                end: +endTime,
                text: transcript,
            },
        })
            .then(() => {
                enableChapterRegeneration(true);
                toast.success("Successfully saved the transcript.");
                onSave();
                onClose();
            })
            .catch((err) => {
                console.log(err);
                toast.error("Error saving the transcript.");
            })
            .finally(() => {
                setSaving(false);
            });
    }, [videoCode, startTime, endTime, transcript, enableChapterRegeneration, onClose]);

    return (
        <Modal show onHide={onClose} centered size="xl" style={{ zIndex: 10000 }}>
            <Modal.Header closeButton>
                <Modal.Title>New Transcript</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="my-3">
                    <Col xs="6">
                        <Form.Group className="mb-2">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="00.00"
                                value={startTime}
                                onChange={(e) => setStartTime(e.target.value)}
                                disabled={saving}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs="6">
                        <Form.Group className="mb-2">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="00.00"
                                value={endTime}
                                onChange={(e) => setEndTime(e.target.value)}
                                disabled={saving}
                            />
                        </Form.Group>
                    </Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Transcript</Form.Label>
                        <Form.Control
                            as="textarea"
                            value={transcript}
                            onChange={(e) => setTranscript(e.target.value)}
                            disabled={saving}
                            style={{ minHeight: 80 }}
                        />
                    </Form.Group>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'end' }}>
                        <Button
                            variant="primary"
                            onClick={handleSave}
                            disabled={saving || !startTime || !endTime || !transcript.trim()}
                        >
                            {saving ? "Saving..." : "Save Transcript"}
                        </Button>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default AddTranscriptModal;